/** Display name for CRC / Gantt (matches backend GANTT_APP_NAME). */
export const GANTT_APP_NAME = 'Caribbean Regional Connectivity';

export {
  isCaribSite,
  isGanttHost,
  isCaribMarketingHost,
  CARIB_SITE_URL,
  GANTT_APP_URL,
  GANTT_LOGIN_URL,
} from '../carib/caribSiteUtils';
